// Razorpay Standard Checkout helpers.
// Frontend-safe key (test mode). Never put the key secret here — that lives
// only on the backend and is used to verify the payment signature.
export const RAZORPAY_KEY = 'rzp_test_ShpRUtfOJXYrb3';

const SCRIPT_SRC = 'https://checkout.razorpay.com/v1/checkout.js';

// Inject the Razorpay checkout script once. Subsequent calls short-circuit
// because window.Razorpay is set on first load. Resolves true on success
// (so callers can fall back to a friendly error if the network blocks it).
export const loadRazorpayScript = () => new Promise((resolve) => {
  if (typeof window === 'undefined') return resolve(false);
  if (window.Razorpay) return resolve(true);

  const existing = document.querySelector(`script[src="${SCRIPT_SRC}"]`);
  if (existing) {
    existing.addEventListener('load', () => resolve(true));
    existing.addEventListener('error', () => resolve(false));
    return;
  }

  const script = document.createElement('script');
  script.src = SCRIPT_SRC;
  script.async = true;
  script.onload = () => resolve(true);
  script.onerror = () => resolve(false);
  document.body.appendChild(script);
});
